<template>
  <article class="contact" id="contact">
    <form
      v-if="getT"
      action="javascript:void(0);"
      class="responsive-content-column"
    >
      <input
        name="firstName"
        v-model="form.firstName"
        type="text"
        :placeholder="getT.static.contact[0].inputs[0].label + '*'"
        required
        v-on:focus="
          logFieldReceivesFocus(getT.static.contact[0].inputs[0].label)
        "
      />
      <input
        name="lastName"
        v-model="form.lastName"
        type="text"
        :placeholder="getT.static.contact[0].inputs[1].label + '*'"
        required
        v-on:focus="
          logFieldReceivesFocus(getT.static.contact[0].inputs[1].label)
        "
      />
      <input
        name="email"
        v-model="form.email"
        type="email"
        :placeholder="getT.static.contact[0].inputs[2].label + '*'"
        required
        v-on:focus="
          logFieldReceivesFocus(getT.static.contact[0].inputs[2].label)
        "
      />
      <input
        name="tel"
        v-model="form.phone"
        type="tel"
        :placeholder="getT.static.contact[0].inputs[3].label"
        v-on:focus="
          logFieldReceivesFocus(getT.static.contact[0].inputs[3].label)
        "
      />
      <input
        name="address"
        v-model="form.address"
        type="text"
        :placeholder="getT.static.contact[0].inputs[4].label + '*'"
        required
        v-on:focus="
          logFieldReceivesFocus(getT.static.contact[0].inputs[4].label)
        "
      />
      <input
        name="zip"
        v-model="form.zip"
        type="text"
        :placeholder="getT.static.contact[0].inputs[5].label + '*'"
        required
        v-on:focus="
          logFieldReceivesFocus(getT.static.contact[0].inputs[5].label)
        "
      />
      <select name="country" @change="selectCountry($event.target.value)">
        <option disabled>Country</option>
        <option
          v-for="(item, index) in languages.options"
          :key="`${item.name}-${index}`"
          :value="item.value"
          :selected="
            languages.default_selected.toLowerCase() === item.name.toLowerCase()
          "
        >
          {{ item.name }}
        </option>
      </select>
      <select
        name="likelyUse"
        @change="selectLikelyUse($event.target.value)"
        :class="{ unset: !form.likelyUse }"
      >
        <option disabled selected hidden>
          {{ getT.static.contact[0].inputs[8].label }}
        </option>
        <option
          v-for="item in getLikelyUseOptions"
          :key="item.value"
          :value="item.value"
        >
          {{ item.localText }}
        </option>
      </select>
      <label for="emailOptIn" class="check-container" @click="toggleEmailOptIn"
        >{{ getT.static.contact[0].inputs[7].label }}
        <input name="emailOptIn" type="checkbox" />
        <span class="checkmark">
          <img
            v-if="form.emailOptIn"
            src="./../assets/icons/checkbox-selected.svg"
          />
          <img
            v-if="!form.emailOptIn"
            src="./../assets/icons/checkbox-deselected.svg"
          />
        </span>
      </label>
      <button :disabled="submitting" v-on:click="submit">
        <!-- SVG loading icon by Sam Herbert (@sherb), for everyone. More @ http://goo.gl/7AJzbL  -->
        <svg
          v-if="submitting"
          width="44"
          height="44"
          viewBox="0 0 44 44"
          xmlns="http://www.w3.org/2000/svg"
          stroke="#fff"
        >
          <g fill="none" fill-rule="evenodd" stroke-width="2">
            <circle cx="22" cy="22" r="1">
              <animate
                attributeName="r"
                begin="0s"
                dur="1.8s"
                values="1; 20"
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.165, 0.84, 0.44, 1"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-opacity"
                begin="0s"
                dur="1.8s"
                values="1; 0"
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.3, 0.61, 0.355, 1"
                repeatCount="indefinite"
              />
            </circle>
            <circle cx="22" cy="22" r="1">
              <animate
                attributeName="r"
                begin="-0.9s"
                dur="1.8s"
                values="1; 20"
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.165, 0.84, 0.44, 1"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-opacity"
                begin="-0.9s"
                dur="1.8s"
                values="1; 0"
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.3, 0.61, 0.355, 1"
                repeatCount="indefinite"
              />
            </circle>
          </g>
        </svg>
        <span v-if="!submitting && getT">{{
          getT.static.contact[0].submit_text
        }}</span>
        <span v-if="submitting && getT">{{
          getT.static.contact[0].submitting_text
        }}</span>
      </button>
      <p v-if="error" class="error">
        <img src="../assets/icons/alert-icon.svg" />{{ errorMsg }}
      </p>
      <p class="opt-out-link" @click="gotoRoot">{{ rtsData.text }}</p>
    </form>
    <footer>
      <div class="content responsive-content-column">
        <p v-if="getT">† {{ getT.static.contact[0].disclaimer }}</p>
        <br />
        <p v-if="getT">
          * <span>{{ getT.static.contact[0].required_notice }}</span>
        </p>
      </div>
    </footer>
  </article>
</template>
<script>
import FormSubmit from '../formSubmit.js';
import { mapGetters } from 'vuex';
import Bugsnag from '@bugsnag/js';

export default {
  name: 'Contact',
  data: function() {
    return {
      form: {
        firstName: window.formDebug ? 'FIRST NAME TEST' : '',
        lastName: window.formDebug ? 'LAST NAME TEST' : '',
        email: window.formDebug ? 'TEST@TEST.TEST' : '',
        phone: window.formDebug ? '555-5555' : '',
        address: window.formDebug ? 'TEST ST' : '',
        zip: window.formDebug ? '01234' : '',
        country: '',
        csrf: '',
        likelyUse: window.formDebug ? 'competitive-swimming' : '',
        emailOptIn: false
      },
      error: null,
      errorMsg: 'Sorry! The webpage ran into an unknown error.',
      submitting: false
    };
  },
  computed: {
    ...mapGetters(['rtsData', 'languages', 'getT', 'currPool']),
    getLikelyUseOptions() {
      if (!this.getT) return [];

      const arr = [];
      try {
        for (
          let i = 0;
          i < this.getT.static.contact[0].inputs[8].options.length;
          i++
        ) {
          arr.push({
            localText: this.getT.static.contact[0].inputs[8].options[i].name,
            value: this.getT.static.contact[0].inputs[8].options[i].value
          });
        }
      } catch (e) {
        console.log('e', e);
        Bugsnag.notify(e);
      }
      return arr;
    }
  },
  mounted: function() {
    this.form.country = this.getStartingSelectedCountry();
  },
  methods: {
    getStartingSelectedCountry: function() {
      /*
        The preliminary selected country is set based on the currently active language locale.
      */
      if (this.languages && this.languages.default_selected) {
        const theLanguage = this.languages.options.find(
          item =>
            this.languages.default_selected.toLowerCase() ===
            item.name.toLowerCase()
        );
        return theLanguage.value;
      } else {
        /*
          form should not display unless translation data is found,
          so this value should not end up getting submitted.
        */
        return '';
      }
    },
    selectCountry: function(country) {
      this.form.country = country;

      // track event for Google Analytics
      this.$gtag.event(country + ' Country Selection', {
        event_category: 'Summary Activity',
        event_label: country + ' Country Selection'
      });
    },
    selectLikelyUse: function(value) {
      this.form.likelyUse = value;

      // track event for Google Analytics
      this.$gtag.event(value + ' Likely Use Selection', {
        event_category: 'Summary Activity',
        event_label: value + ' Likely Use Selection'
      });
    },
    gotoRoot() {
      // track event for Google Analytics
      this.$gtag.event('No Thanks Clicked', {
        event_category: 'Summary Activity',
        event_label: 'No Thanks Clicked'
      });
      window.location.href = this.rtsData.url;
    },
    toggleEmailOptIn() {
      this.form.emailOptIn = !this.form.emailOptIn;
      if (this.form.emailOptIn) {
        this.$gtag.event('Email Opt-In Clicked', {
          event_category: 'Summary Activity',
          event_label: 'Email Opt-In Clicked'
        });
      } else {
        this.$gtag.event('Email Opt-Out Clicked', {
          event_category: 'Summary Activity',
          event_label: 'Email Opt-Out Clicked'
        });
      }
    },
    submit: async function() {
      // clear error before validating form input
      this.error = false;
      this.errorMsg = '';

      // validate required fields
      switch ('') {
        case this.form.firstName.trim(): 
          this.errorMsg = this.getT.static.contact[0].inputs[0].error_message;
          this.error = true;
          break;
        case this.form.lastName.trim(): 
          this.errorMsg = this.getT.static.contact[0].inputs[1].error_message;
          this.error = true;
          break;
        case this.form.email.trim(): 
          this.errorMsg = this.getT.static.contact[0].inputs[2].error_message;
          this.error = true;
          break;
        case this.form.zip.trim(): 
          this.errorMsg = this.getT.static.contact[0].inputs[5].error_message;
          this.error = true;
          break;
        case this.form.address.trim(): 
          this.errorMsg = this.getT.static.contact[0].inputs[4].error_message;
          this.error = true;
          break;
        case this.form.country.trim(): 
          this.errorMsg = this.getT.static.contact[0].inputs[6].error_message;
          this.error = true;
          break;
      }
      // validate email address
      if (!/\S+@\S+\.\S+/.test(this.form.email.trim())) {
        this.errorMsg = this.getT.static.contact[0].inputs[2].bad_email_message;
        this.error = true;
      }

      // if form input is valid, send to API
      if (!this.error) {
        this.submitting = true;
        // class exported by FormSubmit.js contains the form submission code
        const fs = new FormSubmit(this.$store, this.form)
        fs.submit()
          .then(() => {
            console.log('Form submission successful');
            // Handle success response
            this.redirectToEP();
          })
          .catch(error => {
            console.log('Form submission failed. Error:', error);
            this.submitting = false;
            this.error = true;
            this.errorMsg = error.errorMessage ? error.errorMessage : 'An error occurred';
            Bugsnag.notify(new Error(this.errorMsg));
          });
      }
    },
    // handle success
    redirectToEP: function() {
      // if testing with dev API
      if (process.env.VUE_APP_DEV_API) {
        console.log('handling success response from dev API');
        // safeguard in case someone deploys to prod with this env var set
        this.errorMsg = 'Development API in use.'; 
        this.error = true; 
      } else {
        // track event for Google Analytics
        this.logFormSubmission(
          this.currPool.title,
          this.$store.getters.priceTotal,
          this.getT ? this.getT.static.currency_code : ''
        );
        // Redirect to success page
        if (this.$store.getters.categoryTagOfSelectedModel === 'spa') {
          window.location.href = this.$store.getters.getThankYouPageSpa;
        } else {
          window.location.href = this.$store.getters.getThankYouPagePool;
        }
      }
    },
    logFieldReceivesFocus(fieldLabel) {
      // track event for Google Analytics
      this.$gtag.event(fieldLabel + ' Summary Field Clicked', {
        event_category: 'Summary Activity',
        event_label: fieldLabel + ' Summary Field Clicked'
      });
    },
    logFormSubmission(selectedPool, msrpAmount, currency) {
      // track event for Google Analytics
      this.$gtag.event('Configurator Form Submitted', {
        event_category: 'Conversion',
        event_label: 'Configurator Form Submitted',
        selected_pool: selectedPool,
        msrp_amount: msrpAmount,
        currency: currency
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@mixin placeholder-style {
  text-transform: unset;
  color: rgba(255, 255, 255, 0.6);
  letter-spacing: unset;
  font-family: 'Europa Regular';
}
article.contact {
  position: relative;
  z-index: 52;
  width: 100%;
  background-color: $navy;
  display: -webkit-box;
  display: -webkit-flex;
  display: -webkit-flexbox;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: flex-end;
  form {
    width: 100%;
    max-width: 100%;
    padding: 1em 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: -webkit-flexbox;
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    margin: 1em 0;
    input,
    select {
      font-size: 1.124rem;
      font-family: 'Europa Regular', sans-serif;
      width: 100%;
      margin: 0.5em 0;
      padding: 1.2em 0.7em;
      color: white;
      background-color: $shallow-navy;
      border: 2px solid white;
      border-radius: 0;
      padding-right: 3em;
      overflow: hidden;
    }
    input {
      outline: none;
      &::placeholder,
      &::-webkit-input-placeholder {
        @include placeholder-style;
      }
      &:focus {
        border-color: lighten($aqua, 20%);
        background-color: darken($shallow-navy, 2%);
      }
    }
    select {
      text-transform: uppercase;
      outline: none;
      // Remove default arrow
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      -webkit-appearance: none;
      -moz-appearance: none;
      // Custom arrow
      background-image: url('../assets/icons/lg-down-arrow.svg');
      background-position: center right 1.6rem;
      background-size: 1rem;
      background-repeat: no-repeat;
      &.unset {
        @include placeholder-style;
      }
      option {
        color: white;
        text-transform: uppercase;
        &[disabled] {
          @include placeholder-style;
        }
      }
      @media #{ $desktop } {
        & {
          cursor: pointer;
        }
      }
    }

    .check-container {
      display: block;
      position: relative;
      font-size: 0.875rem;
      line-height: 1.125rem;
      padding-top: 0.2em;
      margin: 0.5em 0;
      padding-left: 2.7em;
      margin-bottom: 12px;
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      color: $lighter-gray;
    }
    .check-container input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }
    .checkmark {
      display: flex;
      position: absolute;
      top: 0;
      left: 0;
      width: 1.7em;
      height: 1.7em;
      margin-right: 0.5em;
      img {
        width: 100%;
        height: 100%;
        &:hover {
          background-color: rgba(255, 255, 255, 0.1);
        }
      }
    }
    button {
      font-family: 'Europa Bold';
      margin: 0.5em 0 2em;
      font-size: 18px;
      letter-spacing: 2.5px;
      cursor: pointer;
      svg {
        height: 1.4em;
        margin: 0 0.2em -0.3em 0;
      }
    }
    p {
      color: $lighter-gray;
    }
    a:link {
      color: #00a6a2;
      text-decoration: underline;
    }
    a:visited {
      color: #00a6a2;
      text-decoration: underline;
    }
    a:hover {
      color: #00d3d1;
      text-decoration: underline;
    }
    a:active {
      color: #00d3d1;
      text-decoration: underline;
    }
    p.error {
      margin-left: 3em;
      color: white;
      font-weight: bold;
      font-size: 1.2rem;
      img {
        width: 2rem;
        height: 2rem;
        margin: -0.5em 0.5em -0.5rem -2.5em;
      }
    }
  }
  .form-submitted {
    width: 100%;
    padding: 1.5em;
    h2 {
      margin: 2em 0;
    }
  }
  footer {
    width: 100%;
    background-color: $deep-navy;
    display: -webkit-box;
    display: -webkit-flex;
    display: -webkit-flexbox;
    display: flex;
    flex: 0 0 auto;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
    .content {
      padding-top: 2em;
      padding-bottom: 4em;
      @media only screen and (max-width: #{ $lg }) {
        width: 100%;
      }
      p {
        color: $lighter-gray;
        font-size: 0.875rem;
      }
    }
  }
  @media #{ $desktop } {
    .form-submitted {
      width: 50%;
      margin-left: 50%;
    }
  }
}

.opt-out-link {
  text-align: center;
  font-size: 1em;
  color: $lighter-gray;
  text-decoration: underline;
}
.opt-out-link:hover {
  color: #00d3d1;
  text-decoration: underline;
  cursor: pointer;
}
.opt-out-link:active {
  color: #00d3d1;
  text-decoration: underline;
}
</style>
